import React, { useState } from 'react';
import { PrimaryButton } from '../components/button';
import { Constants } from '../lib/const/constants';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ForgotPin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  // const [message, setMessage] = useState("");

  const submitHandler = async () => {
    if (!email.trim()) {
      toast.error('Please enter your registered email');
      return;
    }

    try {
      setLoading(true);

      const resp = await axios.post(
        Constants.BASE_URL + "API-FX-121-ForgotPassword",
        { email },
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY } }
      );

      // Persist what VerifyEmail needs
      sessionStorage.setItem('user_email', email);
      if (resp?.data?.token) {
        // If your VerifyEmail expects "registrationToken", store it under that key
        sessionStorage.setItem('registrationToken', resp.data.token);
      }

      // setMessage(
      //   "We've sent you an email with instructions on how to reset the 6 digit PIN (also check the Spam folder)"
      // );

      // Navigate to Email OTP verification
      navigate('/Checkyouremail');
    } catch (err) {
      const apiMsg = err?.response?.data?.message || 'Something went wrong. Please try again.';
      console.log(err?.response?.data || err);
      toast.error(apiMsg);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="min-h-screen w-full bg-white flex flex-col">
      <div className="w-full border-b border-[#0B214E33] py-6 px-6">
        <img src="/fx_logo_old.png" alt="FXMaster Logo" className="w-[160px]" />
      </div>
            {/* <ToastContainer /> */}

      <div className='flex flex-1 items-center justify-center px-4'>
       <div className="text-center">

        
        <h1 className="text-2xl text-left font-semibold mb-2"> Reset PIN</h1>

        {/* Paragraph */}
        <p className="text-sm text-[#0B214E] font-semibold mb-6">
        You will receive an email to your registered email address to create new 6 digit PIN
        </p>

        {/* {message && <div className="text-red-500 mb-4">{message}</div>} */}

        {/* Username Input */}
        <div className="flex items-center mb-4 bg-custom-gray-light rounded-2xl w-full">
          <input
            type="email"
            placeholder="Enter your email id*"
            className="w-full p-2 outline-none rounded-md bg-custom-gray-light placeholder:text-custom-neutral-900 placeholder:text-sm"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

       
        <PrimaryButton
          onClick={submitHandler}
          label={"Continue"}
          loading={loading}
        />

        <div className='my-5 text-left text-[#0B214E] font-semibold'>
          Remember Password?
          <button onClick={()=>navigate('/login')} className="underline text-sm font-semibold">
            &nbsp; Login Here
          </button>
        </div>
      </div>
    </div>
    </div>
  );
}